import Model from '../model';

// function simplifyGps(data, precision: number): { lat: number, lng: number }[] {
//   return simplify(data, precision).map((p: { x: number, y: number, time: number }) => ({
//     lat: p.x,
//     lng: p.y,
//     time: p.time
//   }));
// }

// export function convertSessionData(key, data) {
//   let points = [];
//   if (data instanceof firebase.firestore.Blob) {
//     data = JSON.parse(data._binaryString);
//   }

//   if (key !== 'gps') {
//     for (let timestamp in data) {
//       let y = data[timestamp];
//       points.push([parseInt(timestamp), y]);
//     }

//     return { points };
//   }

//   let gpsPoints, gpsShort;
//   if (Array.isArray(data)) {
//     gpsPoints = data;
//     gpsShort = simplifyGps(data.map(p => ({ x: p.lat, y: p.lng, time: p.time })), 0.00003);
//   } else {
//     let gps = [];
//     // ELSE IS GPS POINTS
//     // let lonRange, latRange;
//     for (let timestamp in data) {
//       const { lat, lon, speed } = data[timestamp];
//       gps.push({ x: lat, y: lon, time: parseInt(timestamp) });
//       points.push([parseInt(timestamp), speed]);
//     }
//     gpsPoints = simplifyGps(gps, 0.000003);
//     gpsShort = simplifyGps(gps, 0.00003);
//   }
// }

export default class SessionDataModel extends Model {
  // points: Point[] = [];
  // gpsPoints: MapPoint;
  // init(snapshot) {
  //   super.init(snapshot);
  //   let points = [];
  //   let { data = {} } = snapshot.data();
  //   if (data instanceof firebase.firestore.Blob) {
  //     data = JSON.parse(data._binaryString);
  //   }
  //   if (this.key !== 'gps') {
  //     for (let timestamp in data) {
  //       let y = data[timestamp];
  //       // if (this.key !== 'rssi') {
  //       //   y = Math.round(y / 1000);
  //       // }
  //       points.push([parseInt(timestamp), y]);
  //     }
  //   } else {
  //     console.log('DATA', data);
  //     if (Array.isArray(data)) {
  //       this.gpsPoints = data;
  //       this.gpsShort = simplifyGps(data.map(p => ({ x: p.lat, y: p.lng, time: p.time })), 0.00003);
  //     } else {
  //       let gps = [];
  //       // ELSE IS GPS POINTS
  //       // let lonRange, latRange;
  //       for (let timestamp in data) {
  //         const { lat, lon, speed } = data[timestamp];
  //         gps.push({ x: lat, y: lon, time: parseInt(timestamp) });
  //         points.push([parseInt(timestamp), speed]);
  //       }
  //       this.gpsPoints = simplifyGps(gps, 0.000003);
  //       this.gpsShort = simplifyGps(gps, 0.00003);
  //     }
  //   }
  //   this.points = points;
  // }
}
